var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseToolTipModal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCloseToolTipModal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.48901063,7.66670266 L14.9559075,2.19979936 C15.4591419,1.69656434 15.4591419,0.880661277 14.9559075,0.377498255 C14.4526731,-0.12573676 13.636843,-0.12573676 13.1336086,0.377498255 L7.66663967,5.84447355 L2.19967079,0.377426261 C1.69643636,-0.125808754 0.880606248,-0.125808754 0.377371823,0.377426261 C-0.125790608,0.880661277 -0.125790608,1.69656434 0.377371823,2.19972736 L5.84434071,7.66663067 L0.377371823,13.133606 C-0.125790608,13.636841 -0.125790608,14.4527441 0.377371823,14.9559071 C0.880606248,15.4591421 1.69643636,15.4591421 2.19967079,14.9559071 L7.66663967,9.48893177 L13.1336086,14.9559071 C13.636771,15.4591421 14.4526731,15.4591421 14.9559075,14.9559071 C15.4591419,14.4526721 15.4591419,13.636841 14.9559075,13.133606 L9.48901063,7.66670266 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit-Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icCloseToolTipModal",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseToolTipModal);
export default __webpack_public_path__ + "static/media/icCloseToolTipModal.6b6ba767a200c517780459dfae105f77.svg";
export { ForwardRef as ReactComponent };